import React, {useRef, useCallback} from "react";
import classNames from "classnames";
import {useSelector} from "react-redux";
import ReactGA from 'react-ga';

import {textMap} from "../common/Localization";

import './AboutSponsored.scss';

const AboutSponsored = () => {
	const sendGa = useCallback(() => {
		ReactGA.event({
			category:"PARTNER",
			action:"타입폼-광고",
			label:"스폰서드광고란-더알아보기"
		});
	}, []);

	const id = useSelector(state => state.ScrollModule.id);

	const showAbout = useRef();

	if(!showAbout.current && id === "aboutSponsored") {
		showAbout.current = true;
	}

	return (
		<div id="aboutSponsored" className="bc_light_blue view_section">
			<div className="about_sponsored_wrap">
				<div className="text_wrap">
					<div className={classNames("title", "c_28")}>{textMap.formatString(textMap.about_sponsored_title, <span className="c_blue">{textMap.about_sponsored_title_2}</span>)}</div>
					<div className={classNames("description", "c_4a")}>{textMap.about_sponsored_text}</div>
					<div className="button_wrap">
						<a href="https://minimap2.imweb.me/#doz_body" target="_blank" rel="noopener noreferrer" onClick={sendGa}>
							<span className={classNames("button", "c_blue")}>
								{textMap.about_sponsored_button}
								<img src={process.env.PUBLIC_URL + "/icon/arrow_right_blue.png"} alt=""/>
							</span>
						</a>
					</div>
				</div>
				<div className="image_wrap">
					<div className="image_drag_wrap">
						<img className={classNames("pc_image", "sc_mockup", showAbout.current ? "show" : "")} src={process.env.PUBLIC_URL + "/img/about_web.png"} alt=""/>
						<img className={classNames("mobile_image", "sc_mockup", showAbout.current ? "show" : "")} src={process.env.PUBLIC_URL + "/img/about_phone.png"} alt=""/>
					</div>
				</div>
			</div>			
			<div className={classNames("about_sponsored_footer", "bc_ff")}>
				<div className={classNames("arc", "bc_light_blue")}></div>
			</div>
		</div>
	);
};

export default AboutSponsored;
